import React, { useEffect, useState } from "react";
import { Bell, BellSlash, X } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";

/**
 * NotifyPermissionPrompt — Mobile V1.
 * Solicita permiso de notificaciones al asesor autenticado UNA sola vez tras
 * una interacción explícita. Nunca bloquea la app si se rechaza.
 */
export function NotifyPermissionPrompt() {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("Notification" in window)) return;
    if (!user || user === false) return;
    if (Notification.permission !== "default") return; // already granted/denied
    if (localStorage.getItem("rf_notif_prompt_dismissed_at")) {
      const dt = Number(localStorage.getItem("rf_notif_prompt_dismissed_at"));
      if (Date.now() - dt < 3 * 24 * 3600 * 1000) return; // wait 3 days
    }
    // Delay a bit so the user gets oriented first
    const t = setTimeout(() => setVisible(true), 4500);
    return () => clearTimeout(t);
  }, [user]);

  const accept = async () => {
    try { await Notification.requestPermission(); } catch { /* noop */ }
    dismiss();
  };
  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem("rf_notif_prompt_dismissed_at", String(Date.now())); } catch {}
  };

  if (!visible) return null;

  return (
    <div
      className="md:hidden fixed left-3 right-3 top-20 z-40 rounded-2xl bg-[#0F0F0F] border border-[#C8A24A]/40 shadow-2xl p-4 flex items-start gap-3"
      data-testid="notify-permission-prompt"
      role="alert"
    >
      <div className="w-10 h-10 rounded-lg bg-[#C8A24A]/15 border border-[#C8A24A]/30 flex items-center justify-center flex-shrink-0">
        <Bell size={20} weight="duotone" className="text-[#C8A24A]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-[#C8A24A]">Recibe avisos de nuevos leads</p>
        <p className="text-xs text-[#C8A24A]/70 mt-0.5 leading-snug">
          Te avisaremos cuando alguien pregunte por tus propiedades. Puedes desactivarlo cuando quieras.
        </p>
        <div className="mt-2 flex gap-2">
          <button
            onClick={accept}
            className="text-xs font-bold bg-[#C8A24A] text-[#0A0A0A] px-3 py-1.5 rounded-full"
            data-testid="notify-permission-accept"
          >
            Activar
          </button>
          <button
            onClick={dismiss}
            className="text-xs font-semibold text-[#C8A24A]/70 px-3 py-1.5"
            data-testid="notify-permission-dismiss"
          >
            Ahora no
          </button>
        </div>
      </div>
      <button onClick={dismiss} className="p-1 -m-1 text-[#C8A24A]/50 hover:text-[#C8A24A]" aria-label="Cerrar" data-testid="notify-permission-close">
        <X size={14} />
      </button>
    </div>
  );
}
